
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatSnackBarModule} from '@angular/material/snack-bar';
import { MatSidenavModule} from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatRadioModule} from '@angular/material/radio';
import { MatStepperModule} from '@angular/material/stepper';
import { MatChipsModule} from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AsyncPipe, CommonModule } from '@angular/common';

const MATERIAL_MODULES = [
     MatBadgeModule,
     MatButtonModule,
     MatButtonToggleModule,
     MatCardModule,
     MatCheckboxModule,
     MatChipsModule,
     MatDatepickerModule,
     MatDialogModule,
     MatDividerModule,
     MatGridListModule,
     MatIconModule,
     MatInputModule,
     MatListModule,
     MatSelectModule,
     MatTableModule,
     MatTabsModule,
     MatToolbarModule,
     MatFormFieldModule,
     MatMenuModule,
     MatGridListModule,
     MatPaginatorModule,
     MatExpansionModule,
     MatSnackBarModule,
     MatSidenavModule,
     MatSortModule,
     MatBottomSheetModule,
     MatSlideToggleModule,
     MatTooltipModule,
     MatRadioModule,
     MatStepperModule,
     MatChipsModule,
     MatProgressSpinnerModule,
     MatAutocompleteModule,
     AsyncPipe,
];

@NgModule({
  imports: [MATERIAL_MODULES], // Import common modules if needed
  exports: MATERIAL_MODULES // Export Material modules so other modules can use them
})
export class SharedMaterialModule { }